export const trackingIds = {
  base: "rx-myaccount-profile",
  updateAddress: "rx-myaccount-update-postal-address",
  updateDob: "rx-myaccount-update-date-of-birth",
  updateEmail: "rx-myaccount-update-email",
  updateLandline: "rx-myaccount-update-home-phone",
  updateMobile: "rx-myaccount-update-mobile-number",
  stepUp: "rx-myaccount-profile-step-up",
};

export const formStack = {
  updateName: {
    formCode: "rx_profile_update_name",
    title: "Name",
  },
};

export const pageRoutes = {
  jointAccountHolder: "/joint-account-holder",
  base: "/",
  updateAddress: {
    form: "/update-postal-address",
    success: "/update-postal-address/success",
  },
  updateDob: {
    form: "/update-date-of-birth",
    success: "/update-date-of-birth/success",
  },
  updateEmail: {
    form: "/update-email-address",
    success: "/update-email-address/success",
  },
  updateLandline: {
    form: "/update-home-phone",
    success: "/update-home-phone/success",
    removeSuccess: "/remove-home-phone/success",
  },
  updateMobile: {
    form: "/update-mobile-phone",
    success: "/update-mobile-phone/success",
  },
  updateName: {
    success: "/update-name/success",
  },
  contactPreferences: {
    form: "/contact-preferences",
  },
};

export const isContactPreferencesRoute = (
  path: string | readonly string[] | undefined
): boolean => {
  if (!path || Array.isArray(path)) {
    return false;
  }
  return path === pageRoutes.contactPreferences.form;
};
